import { apiGet, apiPost } from './client';

export function createShareLink(valuationPublicId) {
  return apiPost(`/api/v1/valuations/${encodeURIComponent(valuationPublicId)}/share`, {});
}

export function getSharedValuation(token) {
  return apiGet(`/api/v1/share/${encodeURIComponent(token)}`);
}
